import { CircularProgress, Stack, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { GLGroupManagementTablePropsType } from "../../../types/container.type";
import DeleteIcon from '@mui/icons-material/Delete';
import { BaseButton } from "../../../components/button/styled";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const GLGroupManagementTable: React.FC<GLGroupManagementTablePropsType> = ({ rows, handleItemClick, selectedGLGroupId }) => {
    const GLGroupManagementTableHeaders = ["Group ID", "GL Name", "GL Balance", "Action"];
    return (
        <BaseTable
            headers={GLGroupManagementTableHeaders}
        >
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow
                            key={index}
                        >
                            <TableCell>{row?.glCode}</TableCell>
                            <TableCell>{row?.glName?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.glBalance ?? 0)}</TableCell>
                            <TableCell>
                                <Stack
                                    direction={"row"}
                                    gap={"calc(var(--flex-gap)/4)"}
                                >
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--primary-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, row.id, "edit")}
                                    >
                                        <Typography
                                            variant={"button"}
                                            fontFamily={"inherit"}
                                            fontWeight={"inherit"}
                                            fontSize={"inherit"}
                                            lineHeight={"inherit"}
                                            color={"inherit"}
                                            textTransform={"inherit"}
                                        >
                                            Edit
                                        </Typography>
                                    </BaseButton>
                                    <BaseButton
                                        variant="contained"
                                        bgcolor="var(--text-salmon-pink-color)"
                                        padding="calc(var(--basic-padding)/4) calc(var(--basic-padding))"
                                        fontweight={500}
                                        fontsize={"14px"}
                                        onClick={(e) => handleItemClick?.(e, { glGroupId: row.id, institutionId: row.institution }, "delete")}
                                    >
                                        {(selectedGLGroupId !== null && selectedGLGroupId === row.id) ? (
                                            <CircularProgress color="inherit" className="loader" />
                                        ) : (
                                            <DeleteIcon />
                                        )}
                                    </BaseButton>
                                </Stack>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}